import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import styles from '../../styles/uitk-egds-sheet.css';
import EGDSSheetContext from '../sheet-context/index.esm.js';
import { classNames } from '../../utils/classnames/index.esm.js';
import { MakeEgdsSizingLength } from '../../utils/egds-sizing-length/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSSheetContent = props => {
  const {
    children,
    className,
    contentDomRef,
    fullSheetContentMaxWidth,
    padded = true
  } = props;
  const baseClassName = 'uitk-sheet-content';
  const sheetContext = React.useContext(EGDSSheetContext);
  const posStyle = sheetContext.maxHeight && {
    maxBlockSize: `${MakeEgdsSizingLength(sheetContext.maxHeight)}`
  } || undefined;
  const sheetContentClasses = getClassNameList(baseClassName, className, {
    [`${baseClassName}-padded`]: padded
  }, fullSheetContentMaxWidth && `${baseClassName}-${fullSheetContentMaxWidth}`);
  return jsx("div", {
    className: sheetContentClasses,
    ref: contentDomRef,
    style: posStyle,
    children: children
  });
};
EGDSSheetContent.displayName = 'EGDSSheetContent';
export { EGDSSheetContent };